'use client';

import React from 'react';
import Link from 'next/link';
import { trackEvent } from '@/lib/analytics';

interface CTASecondaryProps {
  label: string;
  href?: string;
  onClick?: () => void;
  className?: string;
}

export default function CTASecondary({
  label,
  href,
  onClick,
  className = '',
}: CTASecondaryProps) {
  const handleClick = () => {
    trackEvent('CTA_click', { cta_label: label });
    onClick?.();
  };

  const baseClasses = `inline-flex items-center justify-center px-6 py-3 text-sm font-semibold text-primary border border-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-150 tracking-wide ${className}`;

  if (href) {
    return (
      <Link href={href} onClick={handleClick} className={baseClasses}>
        {label}
      </Link>
    );
  }

  return (
    <button type="button" onClick={handleClick} className={baseClasses}>
      {label}
    </button>
  );
}